import UserStore from './stores/UserStore';

export default function(
  currentAuthor,
  manager,
  { teammates, searchStatus, directReports } = {},
) {
  return {
    searchStatus,
    searchTeammates: term => UserStore.search(term, currentAuthor, manager),
    defaultTeammates: getDefaultTeammates(
      currentAuthor,
      manager,
      directReports,
    ),
    teammates,
  };
}

function getDefaultTeammates(currentAuthor, manager, directReports) {
  let defaultTeammates = manager ? [manager, currentAuthor] : [currentAuthor];

  if (directReports) {
    defaultTeammates = defaultTeammates.concat(directReports);
  }
  return defaultTeammates;
}



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/users/UserData.js